import { useEffect, useRef, useState } from "react";

/** Keyframe variant for a quick tile bounce; add as `bounce` next to rest/hover. */
export const TILE_BOUNCE = {
  y: [0, -10, 0, -4, 0],
  scale: [1, 1.08, 1, 1.03, 1],
  transition: { duration: 0.6, times: [0, 0.3, 0.6, 0.8, 1], ease: "easeOut" },
};

/** Returns the variant label for `animate` and an `onTap` handler that plays `bounce` once. */
export const useTapBounce = (rest = "rest") => {
  const [bouncing, setBouncing] = useState(false);
  const timer = useRef(null);
  useEffect(() => () => window.clearTimeout(timer.current), []);
  const onTap = () => {
    setBouncing(true);
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setBouncing(false), 650);
  };
  return [bouncing ? "bounce" : rest, onTap];
};
